import { getOrderItems, getOrderProductRating } from 'analytics/eventDefinitions'
import { getTypeaheadItemType } from 'lib/search/typeaheadUtils'

export interface OptimizelyEvent {
  type: 'event'
  eventName: string
  tags?: any
}

export function searchFromHomepageEvent(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'search-from-homepage',
  }
}

export function clickHomepageNavbarEvent(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'click-homepage-navbar',
  }
}

export function clickHomepageTileEvent(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'click-homepage-tile',
  }
}

export function clickHomepageRecommendationTileEvent(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'click-homepage-recommendation-tile',
  }
}

export function purchaseClickEvent(order: App.Order): OptimizelyEvent {
  const orderItems = getOrderItems(order)
  const orderProductRating = getOrderProductRating(orderItems, order.total)

  return {
    type: 'event',
    eventName: 'transaction',
    tags: {
      revenue: order.total * 100,
      value: orderProductRating,
    },
  }
}

export function auPurchaseClickEvent(order: App.Order): OptimizelyEvent {
  const orderItems = getOrderItems(order)
  const orderProductRating = getOrderProductRating(orderItems, order.total)

  return {
    type: 'event',
    eventName: 'transaction-au',
    tags: {
      revenue: order.total * 100,
      value: orderProductRating,
    },
  }
}

export function addToCartAccommodationEvent(
): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'add-to-cart-accommodation',
  }
}

export function tpfmCarouselClickEvent(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'click-tpfm-carousel',
  }
}

export function accommodationOfferClickedEvent(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'accommodation-offer-clicked',
  }
}

export function successfulSignupEvent(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'signup-complete',
  }
}

export function upgradePackageEvent(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'package-upgraded',
  }
}

export function searchClickOffer(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'search-click-offer',
  }
}

export function searchClickFlashOffer(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'search-click-flash-offer',
  }
}

export function searchClickLpcOffer(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'search-click-lpc-offer',
  }
}

export function searchClickBedbankOffer(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'search-click-bedbank-offer',
  }
}

export function searchClickBedbankOfferAnytimeWithSell(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'search-click-bedbank-offer-anytime-with-sell',
  }
}

export function searchMapClickOffer(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'search-map-click-offer',
  }
}

export function searchMapClickLpcOffer(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'search-map-click-lpc-offer',
  }
}

export function searchMapClickFlashOffer(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'search-map-click-flash-offer',
  }
}

export function searchMapClickBedbankOffer(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'search-map-click-bedbank-offer',
  }
}

export function searchMapPinClickOffer(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'search-map-pin-click-offer',
  }
}

export function searchMapPinClickLpcOffer(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'search-map-pin-click-lpc-offer',
  }
}

export function searchMapPinClickFlashOffer(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'search-map-pin-click-flash-offer',
  }
}

export function searchMapPinClickBedbankOffer(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'search-map-pin-click-bedbank-offer',
  }
}

export function purchaseLpcOffer(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'purchase-lpc-offer',
  }
}

export function clickTourOfferEvent(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'click-tour-offer',
  }
}

/*
 * This is a view tour checkout event, rather than an add to cart event.
 * This will be updated in the future to reflect that.
*/
export function addToCartTourEvent(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'add-to-cart-tour',
  }
}

export function purchaseTourOfferEvent(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'purchase-tour-offer',
  }
}

export function viewOfferEvent(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'view-offer',
  }
}

export function clickCalenderRecommendation(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'click-calender-recommendation',
  }
}

export function viewMapPage(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'view-map-page',
  }
}

export function viewRecommendationOnOfferPage(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'view-recommendation-on-offer-page',
  }
}

export function clickRecommendationOnOfferPage(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'click-recommendation-on-offer-page',
  }
}

export function viewRecommendationOnLpcPage(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'view-recommendation-on-lpc-page',
  }
}

export function clickRecommendationOnLpcPage(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'click-recommendation-on-lpc-page',
  }
}

export function shareOfferEvent(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'share-offer',
  }
}

export function viewTripEvent(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'view-trip',
  }
}

export function interactOfferGallery(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'interact-offer-gallery',
  }
}

export function clickOfferPageReadMore(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'click-offer-page-read-more',
  }
}

export function searchClickTypeahead(pos: number): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'search-click-typeahead',
    tags: {
      value: pos,
    },
  }
}

export function searchClickTypeaheadItem(item: App.SearchItem, pos: number): OptimizelyEvent {
  const type = getTypeaheadItemType(item)
  return {
    type: 'event',
    eventName: `search-click-typeahead-${type}`,
    tags: {
      value: pos,
    },
  }
}

export function clickOfferTruncatedText(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'click-offer-truncated-text',
  }
}

export function clickOfferTruncatedTextOfferType(offerType: App.OfferListOfferType): OptimizelyEvent {
  return {
    type: 'event',
    eventName: `click-offer-truncated-text-${offerType}`,
  }
}

export function scrollToOfferPackageOptions(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'scroll-to-offer-package-options',
  }
}

export function scrollToOfferPackageOptionsOfferType(offerType: App.OfferListOfferType): OptimizelyEvent {
  return {
    type: 'event',
    eventName: `scroll-to-offer-package-options-${offerType}`,
  }
}

export function insurancePurchaseEvent(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'insurance-purchase',
  }
}

export function bookingProtectionPurchaseEvent(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'booking-protection-purchase',
  }
}
